// extracted by mini-css-extract-plugin
export default {"input":"register_input__YNasz"};